import React from "react";
import { Sparkles } from "lucide-react";

interface CelebrationBannerProps {
  language: string;
}

const CelebrationBanner = ({ language }: CelebrationBannerProps) => (
  <div className="bg-gradient-to-r from-green-500 to-emerald-500 text-white p-4 rounded-xl mb-6 animate-pulse shadow-lg">
    <div className="flex items-center justify-center gap-2 flex-wrap text-center">
      <Sparkles className="h-5 w-5" />
      <span className="font-bold">
        {language === 'sv' ? 'Fantastisk ROI!' : 'Excellent ROI!'}
      </span>
      <span>
        {language === 'sv' 
          ? 'Din investering betalar sig på under 3 månader!' 
          : 'Your investment pays for itself in under 3 months!'}
      </span>
      <Sparkles className="h-5 w-5" />
    </div>
  </div>
);

export default CelebrationBanner;
